<script setup>
  import { defineProps, computed, inject } from 'vue'
  import { cssify } from '@/utilities';

  const isDarkMode = inject('isDarkMode')

  const props = defineProps({
    tool: String,
    description: String,
    disabled: Boolean,
    new: Boolean,
  });

  const toolUrl = computed(()=>{
    return cssify(props.tool);
  });

</script>

<template>
  <component
    :is="props.disabled ? 'div' : 'router-link'"
    :to="'/'+toolUrl"
    :class="[
      'tool-card hover-shadow group flex flex-col min-h-100 items-stretch',
      props.disabled ? 'disabled' : '',
      props.new ? 'relative overflow-hidden border border-primary ' : '',
    ]"
  >
    <div
      v-if="props.new"
      class="absolute top-4 -right-12"
    >
      <div class="text-sm bg-primary-hover text-white text-center font-display rotate-45 py-1 px-16">NEW!</div>
    </div>
    <div :class="[
      'bg-tool-'+toolUrl,
      'text-white font-display text-2xl p-4 rounded-t-lg'
    ]">
      {{props.tool}}
    </div>
    <img
      :src="isDarkMode
        ? $router.options.base+'/images/tools/'+toolUrl+'-dark.jpg'
        : $router.options.base+'/images/tools/'+toolUrl+'.jpg'
      "
      class="w-full"
    >
    <div class="p-4 flex-grow flex gap-4 flex-col items-stretch ">
      <p class="flex-grow">{{props.description}}</p>
      <div>
        <div
          v-if="props.disabled"
          class="button bg-gray-500 text-white"
          >Coming Soon</div>
        <router-link
          v-else
          :to="'/'+toolUrl"
          :class="'button bg-tool-'+toolUrl+' text-white group-hover:opacity-75 shadow'">
          Go
        </router-link>
      </div>
    </div>
  </component>

</template>
